export const columns = () => [
  { title: "First Name", dataIndex: "firstName" },
  { title: "Last Name", dataIndex: "lastName" },
  { title: "Email", dataIndex: "email" },
  { title: "Active", dataIndex: "isActive" },
  { title: "Action", dataIndex: "action" }
];
